import Controller from '../abstracts/Controller';

export default class LandingController extends Controller {
  static get COMPONENTS() {
    return [
      'LanguageComponent',
    ];
  }
}
